import sessionDataEntry from 'cccisd-laravel-assignment/dist/components/navigations/sessionDataEntry';
import outcomesDataEntry from 'cccisd-laravel-assignment/dist/components/navigations/outcomesDataEntry';

const navigations = [sessionDataEntry, outcomesDataEntry];

export default navigations;
